import React from "react";
import Column from "@amzn/meridian/column";
import { MastheadMenuButton } from "@amzn/meridian/masthead";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { setIsSideMenuOpen } from "src/store/layoutSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import IncompleteInspectionsDisplayCard from "src/components/pages/inspection/incompleteInspectionsDisplayCard";
import { Button, Icon } from "@amzn/meridian";
import cogTokens from "@amzn/meridian-tokens/base/icon/cog";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { isAdminUser } from "src/constants/constants";
import { useNavigate } from "react-router-dom";

const LandingHeader = () => {
  const { isSideMenuOpen } = useAppSelector((state) => state.layout);
  const { ldap } = useAppSelector((state) => state.user);
  const { incompleteInspections } = useAppSelector((state) => state.inspection);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return (
    <Column
      className="landing-page-header"
      width="100%"
      spacingInset="600 400 500"
    >
      <Row>
        <Row
          width={"100%"}
          alignmentHorizontal="justify"
          widths={["fit", "fill", "fit"]}
        >
          <MastheadMenuButton
            onClick={() => dispatch(setIsSideMenuOpen(!isSideMenuOpen))}
            open
          />
          <Column alignmentHorizontal="center">
            <Text type="h200">Safety Genie</Text>
          </Column>
          {!isAdminUser(ldap) && <Column width={32} height={32}></Column>}
          {isAdminUser(ldap) && (
            <Button type="icon" size="small" onClick={() => navigate("/admin")}>
              <Icon tokens={cogTokens}>Settings</Icon>
            </Button>
          )}
        </Row>
      </Row>
      {/* Incomplete Inspections Section */}
      {incompleteInspections.length > 0 && (
        <Column spacing="300" spacingInset="none 400">
          <Row alignmentHorizontal="justify" alignmentVertical="center">
            <Text type="b500">Incomplete Inspections</Text>
          </Row>
          <Row overflowX="scroll" widths={"fit"}>
            {incompleteInspections.map((inspection) => (
              <IncompleteInspectionsDisplayCard
                key={inspection.inspectionId}
                inspection={inspection}
              />
            ))}
          </Row>
        </Column>
      )}
    </Column>
  );
};

export default LandingHeader;
